import TomSelect from 'tom-select';

const realpressTomSelect = () => {
	const select2Nodes = document.querySelectorAll( 'select.realpress-select2' );
	if ( ! select2Nodes ) {
		return;
	}
	for ( let i = 0; i < select2Nodes.length; i++ ) {
		const select2Node = select2Nodes[ i ];
		let settings = {
			maxOptions:null,
		};
		if ( select2Node.multiple ) {
			let  plugins=  [ 'no_backspace_delete', 'remove_button', 'clear_button', 'change_listener' ];
			settings = {...settings, plugins};
		} else {
			let plugins= [ 'clear_button' ];
			settings = {...settings, plugins};
		}

		new TomSelect( select2Node, settings );
	}
};

export default realpressTomSelect;
